<template>
  <div>
    <div class="bordered mb-3">
      <div class="d-flex gap flex-wrap align-center bg-grey_1 pa-2 bordered-bottom">
        <v-avatar size="small" color="primary-dark">{{ get_initiales(commande_inscription.inscriptions[0]) }}</v-avatar>
        <div>
          <div class="font-weight-bold text-h6">{{ get_coureur_name(commande_inscription.inscriptions[0]) }}</div>
          <div class="text-subtitle-1">{{ get_coureur_club(commande_inscription.inscriptions[0]) }}</div>
        </div>
      </div>
      <div class="pa-2">
        <v-row no-gutters>
          <v-col cols="12" md="3" class="d-flex flex-column gap">
            <div v-if="commande_inscription.gia && commande_inscription.gia.prix"
              class="d-flex flex-wrap align-center gap bordered bg-grey_1">
              <v-avatar color="green-darken-4" density="compact" class="rounded-0">
                <v-icon icon="mdi-shield-account"></v-icon>
              </v-avatar>
              <div>A souscrit à la GIA ({{ commande_inscription.gia.prix }}€)</div>
            </div>
            <div>
              <div class="font-weight-bold">Options/Activités/Articles</div>
              <v-table class="bordered mt-2" density="compact"
                v-if="commande_inscription.list_commandes_options.length > 0">
                <tbody>
                  <tr v-for="(item, index) in commande_inscription.list_commandes_options" :key="index">
                    <td>
                      {{ item.quantite }}x <b>{{ item.nom }}</b>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <div v-else>Aucune option liée à cette inscription</div>
            </div>
            <div v-if="commande_inscription.donation" class="d-flex flex-wrap align-center gap bordered bg-grey_1">
              <v-avatar color="primary-dark" density="compact" class="rounded-0">
                <v-icon icon="mdi-gift"></v-icon>
              </v-avatar>
              <div>Donation {{ commande_inscription.donation.montant }}€</div>
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <InscriptionItem v-for="item in commande_inscription.inscriptions" :item="item"
              :all_commande_inscription="commande_inscription" :gia="commande_inscription.gia" :key="item.id">
            </InscriptionItem>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import InscriptionItem from "./Inscription_Item.vue";

export default {
  components: {
    InscriptionItem,
  },

  data() {
    return {
      commande_inscription: {},
    };
  },
  props: ["item"],
  computed: {
    valid_options() {
      let options = [];
      for (let option in this.commande_inscription.list_commandes_options) {
        if (this.commande_inscription.list_commandes_options[option].supprime == 0) {
          options.push(this.commande_inscription.list_commandes_options[option]);
        }
      }
      return options;
    },
  },
  methods: {
    get_initiales(inscription) {
      if (inscription == undefined) return "NC";
      if (inscription.nom == undefined || inscription.prenom == undefined) return "NC";
      return inscription.nom[0].toUpperCase() + inscription.prenom[0].toUpperCase();
    },
    get_coureur_name(inscription) {
      if (inscription == undefined) return "";
      return inscription.nom + " " + inscription.prenom;
    },

    get_coureur_club(inscription) {
      if (inscription == undefined) return "";
      if (inscription.champs.club && inscription.champs.club != "") {
        return "Club : " + inscription.champs.club;
      }
      return "";
    },
  },
  created() {
    this.commande_inscription = this.item;
  },
};
</script>

<style lang="scss" scoped></style>